/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Partner_Admin_Commission_Ready_To_ApproveInputs */



/**
* | output |
* | --- |
* | "{count} ready to approve" |
*
* @param {Partner_Admin_Commission_Ready_To_ApproveInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_commission_ready_to_approve = /** @type {((inputs: Partner_Admin_Commission_Ready_To_ApproveInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Commission_Ready_To_ApproveInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} freigabebereit`)
	return /** @type {LocalizedString} */ (`${i?.count} ready to approve`)
});